import { MEMBERSHIP_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import {
  IMembershipGeneralDetailsPostBody,
  IMembershipGeneralDetailsPostResponse,
} from "@/api_framework/api_modals/Membership";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useMembershipCreateGeneralDetailsAPI = () => {
  const configuration = useConfiguration();
  const [_membership_id, setMembership_id] = useState<string>(null);
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (filterParams: IMembershipGeneralDetailsPostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(MEMBERSHIP_MODULE?.MEMBERSHIP_CREATE?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IMembershipGeneralDetailsPostResponse>) => {
            if (res.data.status === true) {
              setMembership_id(res.data.data.membership_id);
              toast.success("Membership has been created.");
              return { status: true, message: res.data.data.membership_id };
            } else {
                
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            setMembership_id(null);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        setMembership_id(null);
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
